<template>
  <div class="p2p-page narrow">
    <div class="p2p-between">
      <div class="p2p-stack" style="gap:6px">
        <span class="p2p-kicker">{{ scheduled ? 'Scheduled' : 'Publishing' }}</span>
        <h1 class="p2p-h1">{{ headline }}</h1>
        <p class="p2p-lead">{{ summary }}</p>
      </div>
      <div class="p2p-row">
        <router-link :to="'/projects/' + $route.params.id" class="p2p-btn outline">Open project</router-link>
        <router-link :to="'/create/' + $route.params.id + '/publish?tab=automate'" class="p2p-btn">Put it on autopilot</router-link>
      </div>
    </div>
    <div v-if="error" class="p2p-alert bad">{{ error }}</div>
    <div class="p2p-row" style="gap:8px">
      <span class="p2p-chip good mono">{{ count('published') }} published</span>
      <span v-if="count('publishing') + count('queued')" class="p2p-chip mono"><span class="p2p-dot is-accent pulse"></span>{{ count('publishing') + count('queued') }} in progress</span>
      <span v-if="count('scheduled')" class="p2p-chip mono">{{ count('scheduled') }} {{ scheduled ? 'scheduled' : 'waiting their turn' }}</span>
      <span v-if="attention" class="p2p-chip bad mono">{{ attention }} need attention</span>
    </div>
    <div class="p2p-stack" style="gap:10px">
      <DeliveryRow v-for="delivery in deliveries" :key="delivery.id" :delivery="delivery" @changed="replace" />
    </div>
  </div>
</template>

<script>
import DeliveryRow from '../components/DeliveryRow.vue';
import { get, message } from '../api';
import { poller } from '../poll';

export default {
  name: 'Results',
  components: { DeliveryRow },
  data: () => ({ deliveries: [], error: '', loop: null }),
  computed: {
    scheduled() { return this.deliveries.length && this.deliveries.every(item => item.mode === 'schedule'); },
    // Still moving on its own: in flight, waiting for its turn on the account, or about to be retried.
    moving() {
      return this.count('publishing') + this.count('queued')
        + this.deliveries.filter(item => item.state === 'scheduled' && item.mode === 'now').length
        + this.deliveries.filter(item => item.retry_pending).length;
    },
    attention() { return this.deliveries.filter(item => (item.state === 'failed' && !item.retry_pending) || item.state === 'needs_credits').length; },
    headline() {
      if (!this.deliveries.length) return 'Starting…';
      if (this.scheduled) return 'Your posts are scheduled';
      if (this.moving) return 'Publishing your posts';
      const failed = this.attention;
      if (failed && !this.count('published')) return 'These posts were not published';
      return failed ? 'Published, with a few problems' : 'Your posts are live';
    },
    summary() {
      if (this.scheduled) return 'They will publish at the times below. You can move or cancel any of them from Posts.';
      return 'Each network confirms on its own. A failed post costs nothing; temporary network errors are retried automatically.';
    }
  },
  mounted() {
    this.loop = poller(() => this.load(), 3000);
    this.loop.start();
  },
  beforeDestroy() { if (this.loop) this.loop.stop(); },
  methods: {
    count(state) { return this.deliveries.filter(item => item.state === state).length; },
    async load() {
      try {
        this.deliveries = (await get('/deliveries', { group: this.$route.params.group })).deliveries;
        this.$store.dispatch('publisher/loadWorkspace');
      } catch (error) {
        this.error = message(error);
      }
      return this.moving > 0 || !this.deliveries.length;
    },
    replace(updated) {
      const index = this.deliveries.findIndex(item => item.id === updated.id);
      if (index >= 0) this.$set(this.deliveries, index, updated); else this.deliveries.push(updated);
      this.loop.stop();
      this.loop.start();
    }
  }
};
</script>
